import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class PackagingManagerService {
  constructor(private http: HttpClient) {}

  getUnassigned(filters?): Observable<any[]> {
    return this.http.get<any[]>(`${API}packaging-manager`, {
      params: this.buildParams(filters)
    });
  }

  getAssigned(filters?): Observable<any[]> {
    return this.http.get<any[]>(`${API}packaging-manager/assigned`, {
      params: this.buildParams(filters)
    });
  }

  getPackagingUsers(): Observable<any[]> {
    return this.http.get<any[]>(`${API}packaging-manager/packaging-users`);
  }

  assignUser(packagingId, userId) {
    return this.http.put(`${API}packaging-manager/${packagingId}/assign`, {
      userId
    });
  }

  unassignUser(packagingId, userId) {
    return this.http.put(
      `${API}packaging-manager/${packagingId}/unassign`,
      { userId }
    );
  }

  private buildParams(filters) {
    let params = new HttpParams();
    if (filters) {
      Object.keys(filters).forEach(key => {
        const value = filters[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return params;
  }
}
